import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import linkedIn from "../assets/linkedIn.png";

export default function About() {
    return (
        <div className="bg-[#F5F9FF]">

            <Navbar />

            {/* HERO */}
            <section className="py-20 text-center">
                <div className="max-w-7xl mx-auto px-6">

                    <h1 className="text-[42px] md:text-[56px] font-bold text-[#2563EB]">
                        About WamGlammz
                    </h1>

                    <p className="text-gray-600 text-[18px] leading-[30px]">
                        WamGlammz is a purpose-driven beauty and lifestyle booking platform built to transform how people discover,
                        access, and experience professional services.
                    </p>

                </div>
            </section>

            {/* INTRO SECTION */}
            <section className="max-w-5xl mx-auto px-6 md:px-12">

                <div className="bg-white rounded-2xl p-8 shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                    <p className="text-gray-600 leading-[28px]">
                        We connect clients with skilled makeup artists, hairstylists, photographers, choreographers, wellness specialists, and more through a fast, trusted, and intuitive digital experience.
                    </p>
                    <p className="mt-2 text-gray-600 leading-[28px]">
                        Our platformFounded by a beauty pageant winner, model, software developer, and entrepreneur,
                        WamGlammz blends the elegance of beauty with the power of technology all driven by one mission: empower Confidence.
                    </p>

                </div>

            </section>

            {/* SUPPORT SECTION */}
            <section className="max-w-5xl mx-auto px-6 md:px-12 mt-16">

                <h2 className="text-2xl font-semibold text-[#2563EB] mb-6 text-center">
                    We proudly support
                </h2>

                <div className="grid md:grid-cols-2 gap-6">

                    {[
                        "Small and growing beauty professionals",
                        "Domestic violence survivors seeking opportunities",
                        "Low-income families needing access",
                        "Fashion show opportunities",
                        "Pageant contestants & models",
                        "Everyday individuals"
                    ].map((item, index) => (
                        <div
                            key={index}
                            className="bg-white p-6 rounded-xl shadow-[0_10px_25px_rgba(0,31,42,0.06)]"
                        >
                            <p className="text-gray-700">✔ {item}</p>
                        </div>
                    ))}

                </div>
                <div className="mt-8 max-w-4xl mx-auto">
                    <p className="text-gray-600 leading-[28px] text-[16px]">
                        WamGlammz stands for accessibility, trust, and purpose. We uplift communities, expand visibility for professionals, and help clients feel their most confident whether for a pageant, wedding, event, photoshoot, or self-care moment.
                        With WamGlammz, booking beauty and lifestyle services becomes effortless. With WamGlammz, confidence becomes a journey.
                    </p>
                </div>
            </section>

            {/* MISSION & VISION */}
            <section className="max-w-5xl mx-auto px-6 md:px-12 mt-20">
                <h2 className="text-2xl font-semibold text-[#2563EB] mb-6 text-center">
                    MISSION & VISION
                </h2>
                <div className="grid md:grid-cols-2 gap-8">

                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Our Mission
                        </h3>
                        <p className="text-gray-600 leading-[28px]">
                            To make beauty, lifestyle, and wellness services accessible to everyone
                            through seamless technology while empowering confidence and uplifting communities.
                        </p>
                    </div>

                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Our Vision
                        </h3>
                        <p className="text-gray-600 leading-[28px]">
                            To create the world’s most trusted beauty & lifestyle platform where
                            innovation, inclusivity, and purpose come together.
                        </p>
                    </div>

                </div>

            </section>

            {/* FOUNDER STORY & PROFILE CARD */}
            <section className="max-w-5xl mx-auto px-6 md:px-12 mt-20">
                
                <div className="bg-gradient-to-r from-[#0A3FB6] to-[#2FB4FF] text-white p-8 md:p-12 rounded-2xl shadow-xl flex flex-col items-center text-center">

                    <img 
                        src={linkedIn} 
                        alt="Shyaml Punekar" 
                        className="w-48 h-56 md:w-56 md:h-64 rounded-xl object-cover shadow-lg mb-6"
                    />
                    
                    <h3 className="text-2xl md:text-3xl font-bold">
                        Shyaml Punekar
                    </h3>
                    
                    <p className="text-blue-200 font-semibold text-lg mt-2">
                        Founder and CEO of Wamglammz
                    </p>
                    

                    <div className="w-full border-t border-white/20 mt-5 pt-5">
                        <h2 className="text-2xl font-semibold mb-6 text-center">
                            Our Story (Founder’s Story) 
                        </h2>

                        <div className="text-left space-y-4">
                            <p className="text-blue-100 leading-[28px]">
                                WamGlammz began as a simple idea: what if booking high-quality beauty services
                                could be effortless, trustworthy, and inclusive?
                            </p>

                            <p className="text-blue-100 leading-[28px]">
                                Inspired by her journey as a beauty pageant winner, model, software developer, and survivor, our founder saw a gap in the industry. Many people, especially domestic violence survivors and low-income families, struggled to access trusted beauty services.
                            </p>

                            <p className="text-blue-100 leading-[28px]">
                                Professionals also needed a platform to showcase their talent and grow their business. This led to the creation of WamGlammz, a purpose-driven platform where beauty meets technology, and confidence becomes a pathway for real transformation.
                            </p>
                        </div>
                    </div>

                </div>
            </section>

            {/* PREMIUM SEPARATOR */}
            <div className="relative mt-20">
                <div className="h-20 bg-gradient-to-b from-transparent to-[#F5F9FF]" />
                <div className="flex justify-center">
                    <div className="w-[60%] h-[1px] bg-gradient-to-r from-transparent via-blue-300 to-transparent" />
                </div>
            </div>
            <Footer />

        </div>
    );
}